
const LOGININFO = "LOGININFO";
const MESSAGEINFO = "MESSAGEINFO";
const MENULIST = "MENULIST";
export default {
	LOGININFO,
	MESSAGEINFO,
	MENULIST
}
